import { useDispatch, useSelector } from 'react-redux';
import { setPreselectedCardId, setPreselectedCardType } from '../../../../store/showcase/showcase.action';
import { selectPreSelectedCardId, selectPreSelectedCardType } from '../../../../store/showcase/showcase.selector';

import { fadeInUp } from '../../../../animations/Animations';
import { Lift } from '../../../../animations/lift/Lift';


// styles
import {
    FieldDisplayContainer,
    OutlineContainer,
    FieldImg,
    PlacedPlayerCard
} from './FieldDisplay.styles';

// assets
import fieldOutline from '../../../../assets/system/diamond-outline.svg';

// components
import CardDisplay from '../card-display/CardDisplay';
import CardOptions from '../card-options/CardOptions';

// data
const dreamTeamFieldPositions_MLB = {
    "field-DH": {
        id: "field-DH",
        label: "DH",
        position: { top: '68%', left: '85%' }
    },
    "field-C": {
        id: "field-C",
        label: "C",
        position: { top: '68%', left: '44%' }
    },
    "field-1B": {
        id: "field-1B",
        label: "1B",
        position: { top: '48%', left: '68%' }
    },
    "field-2B": {
        id: "field-2B",
        label: "2B",
        position: { top: '34%', left: '54%' }
    },
    "field-3B": {
        id: "field-3B",
        label: "3B",
        position: { top: '48%', left: '20%' }
    },
    "field-SS": {
        id: "field-SS",
        label: "SS",
        position: { top: '34%', left: '34%' }
    },
    "field-LF": {
        id: "field-LF",
        label: "LF",
        position: { top: '20%', left: '15%' }
    },
    "field-CF": {
        id: "field-CF",
        label: "CF",
        position: { top: '8%', left: '44%' }
    },
    "field-RF": {
        id: "field-RF",
        label: "RF",
        position: { top: '20%', left: '75%' }
    }
};

export default function FieldDisplay() {
    const dispatch = useDispatch();
    const preSelectedCardId = useSelector(selectPreSelectedCardId);
    const preSelectedCardType = useSelector(selectPreSelectedCardType);

    const handleCardPreselection = (cardType, id) => {
        dispatch(setPreselectedCardId(id));
        dispatch(setPreselectedCardType(cardType));
    };

    const handleDeselect = () => {
        dispatch(setPreselectedCardId(null));
        dispatch(setPreselectedCardType(null));
    };

    return (
        <FieldDisplayContainer>
            {preSelectedCardType !== "bullpen" ?
                <>
                    <OutlineContainer>
                        <FieldImg
                            src={fieldOutline}
                            alt='field outline'
                            initial="hidden"
                            animate="transparent"
                            variants={fadeInUp}
                            custom={0.2}
                        />
                    </OutlineContainer>
                    {Object.values(dreamTeamFieldPositions_MLB).map(({ id, label, position }) => {
                        // Calculate left position relative to centered 740px image
                        // Image is centered, so: 50% (center) - 370px (half image width) + (percentage of 740px as pixels)
                        const leftPercent = parseFloat(position.left);
                        const leftPixelOffset = (leftPercent / 100) * 740;
                        const leftPosition = `calc(50% - 370px + ${leftPixelOffset}px)`;
                        
                        return (
                        <PlacedPlayerCard
                            key={id}
                            style={{ top: position.top, left: leftPosition }}
                        >
                            <Lift>
                                <CardDisplay
                                    key={id}
                                    id={id}
                                    positionLabel={label}
                                    isActive={preSelectedCardId === id}
                                    onClick={() => handleCardPreselection("field", id)}
                                    onDeselect={handleDeselect}
                                    enableHoverScale={false}
                                />
                            </Lift>
                        </PlacedPlayerCard>
                        );
                    })}
                </>
                :
                <CardOptions />
            }
        </FieldDisplayContainer>
    )
}
